<template>
<div>
    <div class="serverBar">
        <a class="icon icon1">
            <div class="code">
                <img src="../../../static/images/wxcode.png"/>
                <p>中国国际投资贸易洽谈会微信公众号</p>
            </div>
        </a>
        <a class="icon icon2" target="_blank" :href="globalVar.wb">
            <!-- <div class="code">
                <img src="../../../static/images/code.jpg"/>
                <p>洽谈会新浪微博</p>
            </div> -->
        </a>
        <!-- <a class="icon icon3">
            <div class="code">
                <img src="../../../static/images/mdCIFI.jpg"/>
                <p>投洽会客户端</p>
            </div> -->
            <!-- <div class="code" style="right: 270px;">
                <img src="../../../static/images/iosCIFI.png"/>
                <p>投洽会客户端（IOS）</p>
            </div> -->
        <!-- </a>
        <a class="icon icon4">
            <div class="code">
                <img src="../../../static/images/crm.png"/>
                <p>CRM移动端</p>
            </div>
        </a> -->
        <!-- <a class="icon" target="_blank" href="http://new.chinafair.org.cn/2020merrynewyear.html">
            <img src="../../../static/images/newyear.gif"/>
        </a> -->
        <a class="icon icon5">
            <div class="code">
                <img src="../../../static/images/wxXCX.jpg"/>
                <p>云上投洽会小程序</p>
            </div>
        </a>
        
        
    </div>
    <!-- <div class="noticeBox" v-if="$store.state.showNoticeBox" @click="goNewsDetail">
        <h1 class="importment">
            重要通知
            <i class="el-icon-close" style="float:right;font-size: 14px;" @click.stop="$store.state.showNoticeBox=false"></i>
        </h1>
        <div class="flex-sb contentBox" >
            <div class="imgbox"></div>
            <div class="">
                <div class="noticeTitle" style="font-size: 18px;">扫描二维码上传4项健康信息（疫苗接种、核酸检测、健康码、14天内行程卡）</div>
                <div class="textOver" style="-webkit-box-orient: vertical;}">
                    <img src="../../../static/images/attention.png" alt="">
                </div>
            </div>
        </div>
    </div> -->
     <!-- <div class="noticeBox" v-if="$store.state.showNoticeBox" @mouseover="clearTimer" @mouseleave="float()" :style="{left:left+'px',bottom:bottom+'px'}">
        <h1 class="importment">
            新春快乐！
            <i class="el-icon-close" style="float:right;font-size: 14px;" @click.stop="$store.state.showNoticeBox=false,clearInterval(tiemOut)"></i>
        </h1>
        <div class="flex-sb contentBox" >
            <div class="imgbox"></div>
            <div class="">
                <video src="https://www.chinafair.org.cn/cifit/flash/2022_HappyNewYear.mp4" muted="muted" loop style="width: 100%;" controls autoplay></video>
            </div>
        </div>
    </div> -->
    
    <div class="toTop" v-if="toTop" @click="toTopHanlde"></div>
</div>
</template>
<script>
let timer = null;
export default {
    data () {
        return {
            flagBottom:false,
            tiemOut_2:null,
            flagLeft:false,
            tiemOut:null,
            left:5,
            bottom:200,
            scrollTop:0,
            toTop: false,
            showNoticeBox:true,

        }
    },
    mounted(){
        if(!this.toTop) clearInterval(timer)
        window.addEventListener("scroll", ()=>{
            this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        })

        // window.addEventListener("unload", ()=>{
            
        //     console.log('unload')
        // })


    },
    watch:{
        'scrollTop'(val){
            this.toTop = val>500 ? true : false;
        }
    },
    // computed:{
    //     left(){
    //         if(this.left)
    //         {
    //             let a = this.left+1
    //             return a
    //         }
    //         else
    //         {
    //             return 5
    //         }
            
    //     }
    // },
    methods:{
        clearTimer(){
            // console.log(11)
            if(!this.tiemOut!=5)
            {
                window.clearInterval(this.tiemOut)
                 window.clearInterval(this.tiemOut_2)
            }
            
        },
        toTopHanlde(){
            timer = setInterval(function () {
            let osTop = document.documentElement.scrollTop || document.body.scrollTop
            let ispeed = Math.floor(-osTop / 5)
            document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed
            if (osTop === 0) {
                clearInterval(timer)
                }
            }, 30)
        },
        goNewsDetail(){
            
            window.location.href='https://www.chinafair.org.cn/#/NewsCenterLatestDetail?name=%E6%9C%80%E6%96%B0%E5%8A%A8%E6%80%81&id=43818'
        },
        float(){
            const body =  document.getElementsByTagName('body')[0]
            const maxLeft=body.offsetWidth-160
            const minLeft = 5
            const maxBottom=body.offsetHeight-140
            const minBottom = 0
            this.tiemOut=setInterval(()=>{
                if(this.left==maxLeft)
                {
                   
                    this.flagLeft=false
                    
                }
                else if(this.left==minLeft)
                {   this.flagLeft=true
                   
                }
                if(this.flagLeft)
                {
                    this.left+=0.5
                    
                }
                else
                {
                    this.left-=0.5
                }
            },0)

            this.tiemOut_2=setInterval(()=>{
                //  this.bottom--
                if(this.bottom==maxBottom)
                {
                   
                    this.flagBottom=false
                    
                }
                else if(this.bottom==minBottom)
                {   this.flagBottom=true
                   
                }
                if(this.flagBottom)
                {
                    this.bottom+=0.5
                    // console.log(this.bottom)
                    
                }
                else
                {
                    this.bottom-=0.5
                }
            },0)
            
        }
    },
    created(){
        this.float()

    },

}
</script>
<style lang="less" scoped>
@import '../../../static/function.less';
.serverBar{
    position: fixed;
    top: 200px;
    right: 0px;
    width: 42px;
    z-index: 999;
    .icon{
        position: relative;
        display: block;
        width: 42px;
        height: 42px;
        margin-bottom: 15px;
        -webkit-transition: 0.5s all ease-in;
        transition:.5s all ease-in-out;
        .code{
            display: none;
            position: absolute;
            top: 0px;
            right: 50px;
            width: 212px;
            height: 260px;
            padding: 20px 15px;
            text-align: center;
            // background: url("../../../static/images/codeBg.png") center no-repeat;
            background: #fff;
            -webkit-box-shadow: 0 4px 8px rgba(0, 0, 0, 0.5);
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.5);
            border-radius: 4px;
            p{
                margin-top: 15px;
                font-size: @font14;
            }
        }
        &:hover{
            .code{
                display: block;
            }
        }
    }
    .icon1{
        background: url("../../../static/images/icon-wx.png") center no-repeat;
        &:hover{
            background: url("../../../static/images/icon-wx-hover.png") center no-repeat;
        }
    }
    .icon2{
        background: url("../../../static/images/icon-wb.png") center no-repeat;
        &:hover{
            background: url("../../../static/images/icon-wb-hover.png") center no-repeat;
        }
    }
    .icon3{
        background: url("../../../static/images/icon-app.png") center no-repeat;
        &:hover{
            background: url("../../../static/images/icon-app-hover.png") center no-repeat;
        }
    }
    .icon4{
        background: url("../../../static/images/icon-crm.png") center no-repeat;
        &:hover{
            background: url("../../../static/images/icon-crm-hover.png") center no-repeat;
        }
    }
    .icon5{
        background: url("../../../static/images/icon-xcx.png") center no-repeat;
        border-radius: 80px;
        background-size: 100%;
    // border: 1px solid cadetblue;
        &:hover{
            background: url("../../../static/images/icon-xcx-hover.png") center no-repeat;
            border-radius: 80px;
            background-size: 100%;
            border: 0px solid cadetblue;
            // width: 43px;
            // height: 43px;
        }
    }
}
.toTop{
    position: fixed;
    right: 1px;
    bottom: 100px;
    width: 42px;
    height: 42px;
    .shadow(0px);
    background: url("../../../static/images/icon-top.png") center no-repeat;
    cursor: pointer;
}
.noticeBox
{
    position: fixed;
    // top: 5px;
    left: 5px;
    width: 160px;
    // height: 116px;
    overflow: hidden;
    background-color: #fff;
    // border: 1px solid #e4e4e4;
        bottom: 150px;
    z-index: 99;
    border-radius: 2px;
}
.noticeBox:hover
{
    cursor: pointer;
}
h1.importment {
    background-color: #ea0e1e;
    font-size: 13px;
    text-align: center;
    padding: 10px 5px;
    color: #fff;
}
.textOver
{
    overflow: hidden;
    -webkit-line-clamp: 4; 
    -webkit-box-orient: vertical;
    display: -webkit-box;
}
.contentBox {
    padding: 10px;
}
.noticeTitle{
        color: black;
    font-weight: 400;
    margin: 5px 0;
    margin-top: 0px;
}
@media (min-width: 320px) and (max-width: 767px){
    .toTop{
        display: none;
    }
}
</style>





// WEBPACK FOOTER //
// src/components/ServerBar/ServerBar.vue